import { ADULTS_DEFAULT, CHILDREN_DEFAULT } from '../consts/data'
import {
    SET_CITY,
    SET_DATE_START,
    SET_DATE_END,
    SET_ADULTS,
    SET_CHILDREN,
    SET_HOTEL,
    SET_FORM_VALUES_BY_PARAMS,
    RESET_DESTINATIONS,
    RESET_PARTICIPANTS
} from '../actions/apartmentActions'

const today = new Date();
const startDateFrom = new Date(today);
startDateFrom.setDate(today.getDate() + 2);

const initialState = {
    kierunek: null,
    od: startDateFrom.toISOString().split('T')[0],
    do: null,
    dorosli: ADULTS_DEFAULT,
    dzieci: CHILDREN_DEFAULT,
    hotel: null,
    filtry: null
}

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_CITY:
            return { ...state, kierunek: action.payload, hotel: null }
        case SET_DATE_START:
            return { ...state, od: action.payload }
        case SET_DATE_END:
            return { ...state, do: action.payload }
        case SET_ADULTS:
            return { ...state, dorosli: action.payload }
        case SET_CHILDREN:
            return { ...state, dzieci: action.payload }
        case SET_FORM_VALUES_BY_PARAMS:
            const { key, value } = action.payload;

            const val = key === 'dzieci' ?
                value.split(',').map(age => parseInt(age.trim(), 10)) :
                value;

            return {
                ...state,
                [key]: val
            }
        case SET_HOTEL:
            return { ...state, hotel: action.payload, kierunek: null }
        case RESET_DESTINATIONS:
            return { ...state, hotel: null, kierunek: null }
        case RESET_PARTICIPANTS:
            return { ...state, dorosli: ADULTS_DEFAULT, dzieci: CHILDREN_DEFAULT }
        default:
            return state
    }
}
